import React,{useEffect,useState} from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle,Button } from "reactstrap";
import Dropzone from "react-dropzone";
import {httpGet,httpUpload} from "../../common/petitions"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Models from './model.json'
import "./tables.scss";
import "./Puestos.scss";
import DataLoader from "../../components/tableData";
import { useNavigate } from 'react-router-dom'
const rubroviaticos = () => {
  const [uploadResult, setUploadResult] = useState(null);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const nameTemplateExcel = 'PRESUPUESTOMAQ_VIATICOS'
  const downloadTemplate = async () => {
    try {
      const response = await fetch(`/templates_xls/${nameTemplateExcel}.xlsx`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${nameTemplateExcel}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const rowsData = await httpGet(`/rubros/20242025/viaticos`,navigate);
      console.log(rowsData);
      const jsonData = { "columns": Models.headers, "rows": rowsData };
      // console.log("JSONDATA",jsonData);
      setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false)
  };
  const uploadFile = async (file) => {
    setIsUploading(true);
    const formdata = new FormData();
    formdata.append("file", file);
    formdata.append("rubro", 'viaticos');
    try {
      const result = await httpUpload(`/rubros/import`,formdata,navigate);
      setUploadResult(result);
      fetchData();
    } catch (error) {
      console.error("Error uploading file:", error);
    }finally {
      setIsUploading(false);
    }
  };


  const handleAcceptedFiles = (files) => {
    const file = files[0];
    uploadFile(file);
  };


  
  useEffect(() => {
    fetchData();
  }, []); 
  const options = {
    // Other MDBDataTable options
    // ...
    // Custom row rendering function with inline styles
    rowClassName: (row) => (row.rowIndex === 0 ? 'style="position: sticky; top: 0; background-color: #f2f2f2;"' : ''),
  };
  
  
  document.title = "Rubros - Ingreso viaticos - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Rubros" title="Ingreso viaticos"  />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                    <Dropzone onDrop={handleAcceptedFiles}>
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone-container">
                          <div className="btn btn-success dropzone  me-5 " {...getRootProps()}>
                            <input {...getInputProps()} />
                            <span>Subir archivo</span>
                          </div>
                          {uploadResult && (
                            <div className="upload-check">
                              <i className="bx bx-check-circle"></i>
                            </div>
                          )}
                        </div>
                      )}
                    </Dropzone>

                <Button color="light" className="mi-5" onClick={downloadTemplate}>
                  <i className="bx bx-download me-1"></i> Descargar Plantilla (.xlsx)
                </Button>
                <DataLoader isLoading={isLoading} data={data} rubro={"viaticos"}reload={fetchData}/>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default rubroviaticos;
